export const config = {
    api_url: (process.env.NODE_ENV === 'production') ? 'https://roscon.apuntame.click/api' : 'http://ctaz.local/roscon/api'
}

export const limites = {
    '10K': 1400,
    '7K': 124,//250, Modificado para forzar el cierre
    'infantil': 25
}

export const cat = {
    diez: [
        { id: "1", nombre: 'Absoluta (Menores de 35 años)' },
        { id: "2", nombre: 'Veteranos A (de 35 a 44 años)' },
        { id: "3", nombre: 'Veteranos B (de 45 a 54 años)' },
        { id: "4", nombre: 'Veteranos C (de 55  años)' }
    ],
    siete: [
        { id: "13", nombre: 'General' }
    ],
    infantiles: [
        { id: "6", nombre: "Infantil Masculino" },
        { id: "7", nombre: "Alevín Femenino" },
        { id: "8", nombre: "Alevín Masculino" },
        { id: "9", nombre: "Benjamín Femenino" },
        { id: "10", nombre: "Benjamín Masculino" },
        { id: "11", nombre: "Prebenjamín Femenino" },
        { id: "12", nombre: "Prebenjamín Masculino" }

    ]
}

export const tallas = {
    diez: [
        'S', 
        'M', 
        'L', 
        'XL',
        'XXL'
    ],
    inf: [
        'T 2/4',
        'T 4/6',
        'T 8/10',
        'T 12/14'
    ]
}

export const tiendas = [
    { id: "1", nombre: 'Online' },
    { id: "2", nombre: 'Deportes Zenit' },
    { id: "3", nombre: 'Deportes Running' },
    { id: "4", nombre: 'Fartlek Sport' },
    { id: "5", nombre: 'F.A.A' },
    { id: "6", nombre: 'Otros' },
]